import { render, staticRenderFns } from "./BuyersTips.vue?vue&type=template&id=63407f88&scoped=true&"
import script from "./BuyersTips.vue?vue&type=script&lang=ts&"
export * from "./BuyersTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63407f88",
  null
  
)

export default component.exports